import Badge from "@mui/material/Badge";
import Typography from "@mui/material/Typography";
import { primary } from "app/themes/colors";
import { ReactNode } from "react";

type TaskTabLabelProps = {
  children: ReactNode;
  count?: number;
  badgeBgColor?: string;
  badgeColor?: string;
  isActive?: boolean;
};
export default function TaskTabLabel({
  children,
  badgeBgColor,
  badgeColor,
  count,
  isActive,
}: TaskTabLabelProps) {
  return (
    <Badge
      sx={{
        "& .MuiBadge-anchorOriginTopRight": {
          background: badgeBgColor || primary[400],
          color: badgeColor,
          mt: -0.55,
        },
      }}
      badgeContent={count ? count : 0}
      color="primary"
    >
      <Typography fontWeight={isActive ? 700 : 400} fontSize={15}>
        {children}
      </Typography>
    </Badge>
  );
}
